import { render, staticRenderFns } from "./MechanicalNotes.vue?vue&type=template&id=0ae2e4c8&"
import script from "./MechanicalNotes.vue?vue&type=script&lang=js&"
export * from "./MechanicalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VTextarea})
